export default __webpack_public_path__ + "static/media/head-banner.eadf3a37.png";